module.exports = function() {
  return new Worker(__webpack_public_path__ + "0995e91f53c712266b29.worker.js");
};